import React, { Component } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";

class DisplaySwitch extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { checked, updateDisplayType } = this.props;
		return (<Switch
			checked={checked}
			onChange={(isChecked) => {
				updateDisplayType(isChecked);
			}}
		/>);
	}
}

DisplaySwitch.propTypes = {
	updateDisplayType: PropTypes.func.isRequired,
	locationType: PropTypes.object.isRequired,
	statement: PropTypes.object.isRequired,
	checked: PropTypes.bool.isRequired,
};

export default DisplaySwitch;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/DisplaySwitch.js